const TOKEN_KEY = '__esw_token__';
const USER_KEY = '__esw_user__';
const USER_ROLE = '__esw_role__';

export { TOKEN_KEY, USER_KEY, USER_ROLE };
